import React from 'react';
import Rating from '@mui/material/Rating';

const StarRating = ({ value, onChange, readOnly, size }) => (
    <Rating
        value={value ?? 0}
        onChange={onChange}
        readOnly={readOnly}
        size={size || 'medium'}
        precision={readOnly ? 0.5 : 1}
    />
);

export default StarRating;
